import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import JobDetail from "../pages/job-detail/page";
import FAQPage from "../pages/faq/page";
import StaffVoicePage from "../pages/staff-voice/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/job/:id",
    element: <JobDetail />,
  },
  {
    path: "/faq",
    element: <FAQPage />,
  },
  {
    path: "/staff-voice",
    element: <StaffVoicePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;